<template>
	<div>
		<notifications />
		<project-form
			title="Edit Service"
			submitTxt="Update Service"
			:fields="fields"
			:errors="fieldErrors"
			:isLoading="isLoading"
			:onSubmit="saveProject">
		</project-form>
	</div>
</template>

<script>
import Form from './Form.vue';
import { defaultFields } from "./helpers";

export default {
	components: {
		'project-form': Form,
	},
	data() {
		return {
			isLoading: false,
			fields: defaultFields(),
			fieldErrors: defaultFields(),
		}
	},
	async beforeMount() {
		this.isLoading = true;

		try {
			const response = await axios.get(`/projects/${this.$route.params.id}`);
			this.fields = this.parseProjectData(response.data.data);
		} catch {
			this.$notify({
				type: 'error',
				title: 'Oops!',
				text: 'Sorry, an error occured!'
			})
		}

		this.isLoading = false;
	},
	methods: {
		async saveProject(fields) {
			this.isLoading = true;

			try {
				const response = await axios.patch(`/projects/${this.$route.params.id}`, fields);
				
				this.$notify({
					type: 'success',
					title: 'Project Updated',
					text: 'You\'ve successfully updated the project!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		parseProjectData(item) {
			return {
				name: item.name,
				description: item.description,
			}
		},

	}
}
</script>
